import React from "react";
import alina from "../assets/teamsection/alina.png";
import junaid from "../assets/teamsection/junaid.jpg";
import ahmed from "../assets/teamsection/ahmed.jpg";
import shakeel from "../assets/teamsection/shakeel.png";
import hassan from "../assets/teamsection/hassan.jpg";
import umer from "../assets/teamsection/umer.png";

const founders = [
  {
    name: "Umer Kiani",
    role: "CTO",
    imageSrc:umer,
  },
  {
    name: "Junaid Niazi",
    role: "CEO",
    imageSrc: junaid,
  },
];

const teamMembers = [
  {
    name: "Ahmed Abdullah",
    role: "Backend Developer",
    imageSrc: ahmed,
  },
  {
    name: "Shakeel Haider",
    role: "Full Stack Developer",
    imageSrc: shakeel,
  },
  {
    name: "Alina Ahmad",
    role: "Frontend Developer",
    imageSrc: alina,
  },
  {
    name: "Hassan Tauqeer",
    role: "Technical Advisor",
    imageSrc: hassan,
  },
];

const TeamSection = () => {
  return (
    <div className="bg-white mt-16 mx-auto px-4 max-w-full">
      <h2 className="text:xl md:text-3xl  lg:text-4xl font-bold font-sans mb-5 text-custom-red text-center">
        Meet our Founders
      </h2>
      <div className="flex flex-row justify-center space-x-2 mb-10 overflow-x-auto">
        {founders.map((member) => (
          <div key={member.name} className="text-center min-w-max px-2">
            <div className="w-28 h-28 md:w-40 md:h-40 2xl:w-48 2xl:h-48">
              <img
                src={
                  member.imageSrc ||
                  "https://st4.depositphotos.com/14903220/22197/v/450/depositphotos_221970610-stock-illustration-abstract-sign-avatar-icon-profile.jpg"
                }
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <h3 className="mt-3 font-semibold">{member.name}</h3>
            <p className="text-sm text-gray-600">{member.role}</p>
          </div>
        ))}
      </div>
      <h2 className="text:xl md:text-3xl  lg:text-4xl font-bold font-sans mb-5 text-custom-red text-center">
        Meet our Technical Team
      </h2>
      <div className="flex overflow-x-auto pb-10 lg:pb-28 ">
        {teamMembers.map((member) => (
          <div key={member.name} className=" text-center px-2">
            <div className="w-32 h-32 md:w-40 md:h-40 2xl:w-48 2xl:h-48">
              <img
                src={
                  member.imageSrc ||
                  "https://st4.depositphotos.com/14903220/22197/v/450/depositphotos_221970610-stock-illustration-abstract-sign-avatar-icon-profile.jpg"
                }
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <h3 className="mt-3 font-semibold text-sm md:text-base lg:text-lg">
              {member.name}
            </h3>
            <p className="text-xs md:text-sm lg:text-base text-gray-600">
              {member.role}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
